import auth from "../middlewares/auth";
export const users = [
    {
        path: '/users',
        component: () => import(/* webpackChunkName: "notice" */ '../views/users/Index'),
        name: 'users',
        meta: {
            middleware: [
                auth
            ]
        }
    }
];
